import React, { useState, useEffect } from "react";
import Typography from "antd/es/typography/Typography";
import Select from "antd/es/select";
import Button from "antd/es/button";
import Row from "antd/es/grid/row";
import "./WrittenNotes.less";
import { NotesDetailCard } from "../../../component";
import { useSelector } from "react-redux";
import { useGetNotesQuery } from "../../../redux/services/notes";
import { Spin } from "antd";
import { EmptyCard } from "../../../component";
import { useGetStudentBatchesQuery } from "../../../redux/services/batches";

const { Option } = Select;

const Title = Typography;
const WrittenNotes = () => {
  const { student_id } = useSelector((state) => state.auth);
  const [selectedCoaching, setSelectedCoaching] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const {
    data: notesData,
    error: notesError,
    isLoading: notesLoading,
  } = useGetNotesQuery(student_id, selectedCoaching);

  const { data: batches, isLoading: batchLoading } =
    useGetStudentBatchesQuery(student_id);

  const coachingOptions = React.useMemo(() => {
    if (!batches?.data) return [];

    // Transform to options array using Object.entries
    return Object.entries(batches?.data).map(([id, name]) => ({
      value: name.coaching_name,
      label: name.coaching_name,
    }));
  }, [batches]);

  const handleApply = () => {
    // Apply filter logic will be implemented here
  };
  return (
    <div className='written-notes-container'>
      <div className='classes-notes'>
        <Title className='title'>All Notes</Title>
      </div>
      <div style={{ marginTop: "20px" }}>
        {/* Filter Section */}
        <div className='filter-section'>
          <Select
            placeholder='Coaching'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedCoaching(value)}
            allowClear
            options={coachingOptions}
            loading={batchLoading}
          />
          <Select
            placeholder='Course'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedCourse(value)}
            allowClear
          >
            <Option value='Chemistry'>Chemistry</Option>
            <Option value='Physics'>Physics</Option>
            <Option value='Math'>Math</Option>
          </Select>
          <Select
            placeholder='Subject'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedSubject(value)}
            allowClear
          >
            <Option value='Inorganic'>Inorganic</Option>
            <Option value='Mechanics'>Mechanics</Option>
            <Option value='Algebra'>Algebra</Option>
          </Select>
          <Button type='primary' onClick={handleApply}>
            Apply
          </Button>
        </div>

        {/* Cards Section */}
        <Spin spinning={notesLoading}>
          <Row gutter={[16, 16]}>
            {notesData?.data?.length > 0 ? (
              notesData?.data?.map((lecture) => (
                <Row
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <NotesDetailCard
                    key={lecture.id}
                    lectureName={lecture.lecture_name}
                    lectureNumber={lecture.lecture_number}
                    date={lecture.date}
                    coachingLogo={lecture.coachingLogo}
                  />
                </Row>
              ))
            ) : (
              <EmptyCard
                text={
                  notesData?.message || "No Notes found with the given filters"
                }
              />
            )}
          </Row>
        </Spin>
      </div>
    </div>
  );
};

export default WrittenNotes;
